var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadgroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1H10.273C13.533 1 15.165 1 16.297 1.798C16.621 2.026 16.909 2.298 17.152 2.603C18 3.669 18 5.203 18 8.273V10.818C18 13.781 18 15.263 17.531 16.446C16.777 18.349 15.183 19.849 13.161 20.559C11.904 21 10.331 21 7.181 21C5.383 21 4.483 21 3.765 20.748C2.61 20.342 1.699 19.485 1.268 18.398C1 17.722 1 16.875 1 15.182V11",
    stroke: "#1C4980",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 11C18 11.884 17.6488 12.7317 17.0238 13.3568C16.3987 13.9818 15.551 14.333 14.667 14.333C14.001 14.333 13.216 14.217 12.569 14.39C12.2864 14.466 12.0288 14.6149 11.8218 14.8218C11.6149 15.0288 11.466 15.2864 11.39 15.569C11.217 16.216 11.333 17.001 11.333 17.667C11.333 18.1047 11.2468 18.5381 11.0793 18.9425C10.9118 19.3469 10.6663 19.7143 10.3568 20.0238C10.0473 20.3333 9.67986 20.5788 9.27548 20.7463C8.87111 20.9138 8.4377 21 8 21M2 3.5C2.492 2.994 3.8 1 4.5 1M4.5 1C5.2 1 6.508 2.994 7 3.5M4.5 1V9",
    stroke: "#1C4980",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadgroup);
export default __webpack_public_path__ + "static/media/uploadgroup.d8430a0b7cc9d1fceb10c4bdd879cdcb.svg";
export { ForwardRef as ReactComponent };